<template>
    <div class="col">
        <sau-loading v-if="!accountHolder.email && !format">
            <template slot="message">Fetching Account Holder Details</template>
        </sau-loading>

        <!-- updated loading component if in sidebar - remove sau-bx -->
        <div v-else-if="!accountHolder.email" class="text-center p-4 mt-6">
            <img src="/img/spinner.gif" />
            <h6 class="sau-pm-reset">Fetching Account Holder Details</h6>
        </div>

        <sau-apiro-response type="message" v-else :format="format">
            <template slot="message">Oh Darn!</template>
            <template slot="details">
                <p>
                    You do not have permission to {{ format ? 'open a case.' : 'access this page.'}} Please contact {{accountHolder.firstname}} {{accountHolder.lastname}} (account holder) for access.
                    <br>Email
                    <a :href="'mailto:'+accountHolder.email">{{accountHolder.email}}</a>
                </p>
            </template>
        </sau-apiro-response>
    </div>
</template>
<script>
export default {
    // Format flags if its loaded in the sidebar - if so update the message and flag the sau-apiro-response component to remove the sau-bx border
    props: ['format'],
    created() {
        if (!Object.keys(this.accountHolder).length > 0) {
            this.startApp();
        }
    },
    methods: {
        startApp() {
            this.getAccountHolder().then(response => {
                this.$store.commit('setAccountHolder', response.data);
            });
        }
    }
};
</script>
